import TransactionsScreen from './TransactionsScreen';

export default TransactionsScreen;
